import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { AISummary } from '../types/gig/interfaces';

export const isAISummaryPhaseOne = (aiSummary: AISummary, locale: string) =>
    locale === DEFAULT_FIVERR_LOCALE && !!aiSummary.csm_seller_gig;
